import { RootState } from "@/store/store";
import { dimensionByIdSelector } from "@/store/dimensions/selectors/dimensions-data/dimensionByIdSelector";
import { dimensionIdSelector } from "@/store/dimensions/selectors/slice-data/dimensionIdSelector";

export const currentDimensionCategoriesLength = (state: RootState) => {
  const dimensionId = dimensionIdSelector(state);

  if (!dimensionId) {
    return 0;
  }

  const dimension = dimensionByIdSelector(state, dimensionId);

  return dimension?.categories?.length ?? 0;
};
